import { render, staticRenderFns } from "./perquisitesAddNewComponent.vue?vue&type=template&id=55d0a29e&scoped=true"
import script from "./perquisitesAddNewComponent.vue?vue&type=script&lang=js"
export * from "./perquisitesAddNewComponent.vue?vue&type=script&lang=js"
import style0 from "./perquisitesAddNewComponent.vue?vue&type=style&index=0&id=55d0a29e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0a29e",
  null
  
)

export default component.exports